var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.4002,
    y: 5.4002,
    width: 25.2,
    height: 25.2,
    rx: 4.2,
    stroke: "black",
    strokeWidth: 3.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 18.7765C11.1652 16.7058 7.77872 14.4941 6 13.8353C6.64681 15.4824 9.60865 18.7735 11.3362 22.2353C13.755 27.0824 15.8638 30.8 17.1574 33.6C19.2596 30.6353 20.3696 17.6681 22.9787 12.3529C25.8894 6.42353 25.8894 4.94118 28.8 0C26.0511 2.14118 23.6579 4.64471 20.5532 11.3647C17.4485 18.0847 16.6723 24.0471 16.6723 26.1882C15.8638 24.7059 14.7319 21.2471 12.7915 18.7765Z",
    fill: "#B66233"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckImg);
export default __webpack_public_path__ + "static/media/check_img.e1844ac87d45beb9808a6468c6ae056b.svg";
export { ForwardRef as ReactComponent };